<template lang="html">
  <!-- eslint-disable -->
  <svg id="Capa_1"
       height="96px"
       style="enable-background:new 0 0 96 96;"
       version="1.1"
       viewBox="0 0 96 96"
       width="96px"
       xml:space="preserve"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path d="M48.07,47.746c-0.022,0-0.047-0.001-0.07-0.002c-0.024,0.001-0.049,0.002-0.071,0.002c-5.957,0-11.206-1.508-14.308,1.34  c-1.859,1.709-2.642,3.768-2.642,5.985c0,9.261,7.42,10.398,16.949,10.398h0.142c9.529,0,16.949-1.138,16.949-10.398  c0-2.218-0.783-4.276-2.642-5.985C59.275,46.238,54.027,47.746,48.07,47.746z M39.968,60.401c-1.813,0-3.283-2.036-3.283-4.547  s1.47-4.546,3.283-4.546s3.285,2.035,3.285,4.546S41.781,60.401,39.968,60.401z M56.031,60.401c-1.814,0-3.285-2.036-3.285-4.547  s1.471-4.546,3.285-4.546c1.812,0,3.283,2.035,3.283,4.546S57.844,60.401,56.031,60.401z M48,0C21.489,0,0,21.49,0,48  s21.489,48,48,48c26.509,0,48-21.49,48-48S74.509,0,48,0z M52.378,67.701c-0.86,0-2.57,0.002-4.378,0.004  c-1.809-0.002-3.52-0.004-4.379-0.004c-3.803,0-18.863-0.291-18.863-18.445c0-4.177,1.432-7.233,3.775-9.778  c-0.374-0.923-0.393-6.165,1.602-11.183c0,0,4.576,0.502,11.5,5.253c1.451-0.401,3.908-0.601,6.365-0.601  c2.455,0,4.912,0.199,6.365,0.601c6.923-4.751,11.498-5.253,11.498-5.253c1.995,5.018,1.977,10.26,1.603,11.183  c2.344,2.545,3.776,5.602,3.776,9.778C71.242,67.41,56.181,67.701,52.378,67.701z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
</template>

<script>
export default {
};
</script>
